
import { useAuth } from '@/contexts/AuthContext';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

interface AuthGuardProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireEditor?: boolean;
}

const AuthGuard: React.FC<AuthGuardProps> = ({
  children,
  requireAdmin = false,
  requireEditor = false,
}) => {
  const { isAuthenticated, isAdmin, isEditor, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (!isAuthenticated()) {
        navigate('/login');
      } else if (requireAdmin && !isAdmin()) {
        navigate('/dashboard');
      } else if (requireEditor && !isEditor()) {
        navigate('/dashboard');
      }
    }
  }, [isLoading, isAuthenticated, isAdmin, isEditor, navigate, requireAdmin, requireEditor]);

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2 font-mono text-sm">Loading authentication...</span>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGuard;
